import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

interface Language {
  name: string;
  abbreviation: string;
}

const availableLanguages: Language[] = [
  { name: "English", abbreviation: "en" },
  { name: "Español", abbreviation: "es" },
  { name: "Français", abbreviation: "fr" }
];
export { availableLanguages };

const missingKeys = new Set<string>();
function missingKeyHandler(
  langs: string[],
  ns: string,
  key: string,
  res: string
) {
  missingKeys.add(key);

  console.warn(
    `Found missing translation with key ${key}. 
    Logging all currently missing translation keys.`
  );

  console.warn(missingKeys);
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: "languageOnly",
    // lng: "en",
    fallbackLng: "en",
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    whitelist: availableLanguages.map(l => l.abbreviation),
    nonExplicitWhitelist: true,
    saveMissing: true,
    missingKeyHandler:
      process.env.NODE_ENV === "development" ? missingKeyHandler : undefined,
    detection: {
      order: ["localStorage"]
    }
    // debug: true,
  });

export default i18n;
